<template>
  <SiteCronTasksTable :resource-name="resourceName" :site="site" :tasks="tasks" />
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import SiteCronTasksTable from "@/components/smart/tables/SiteCronTasksTable";
import store from "@/store";

export default {
  name: "CronTasks",
  components: {
    SiteCronTasksTable,
  },
  props: {
    resourceName: String,
    site: Object,
  },
  setup(props) {
    const tasks = computed(() => ({
      list: store.getters["siteCron/getTasks"],
      status: store.getters["siteCron/getTasksStatus"],
    }));

    onMounted(() => {
      store.dispatch("siteCron/getTasks", props.site.id);
    });

    return {
      tasks,
    };
  },
};
</script>
